const ZIVOTNI_MINIMUM_JEDNOTLIVCE = 3410;
const NORMATIVNI_NAKLADY_NA_BYDLENI = 5928;
const ZIVOTNI_MINIMUM_NAKLADY_NA_BYDLENI =
	ZIVOTNI_MINIMUM_JEDNOTLIVCE + NORMATIVNI_NAKLADY_NA_BYDLENI;
const BASE_MIN_1 = (ZIVOTNI_MINIMUM_NAKLADY_NA_BYDLENI / 3) * 2;
const BASE_MIN_2 = BASE_MIN_1 / 4;

export function getUnbearableAmount(children, husband) {
	return Math.ceil(children * BASE_MIN_2 + husband * BASE_MIN_2 + BASE_MIN_1);
}

export function getRestOfThePay(pay, unbearableAmount, type) {
	if (pay <= unbearableAmount) {
		return pay;
	}
	const restOfThePay = Math.min(pay - unbearableAmount, ZIVOTNI_MINIMUM_NAKLADY_NA_BYDLENI);

	const third = Math.floor(restOfThePay / 3);
	const zbytekMzdyZaokrouhleni = restOfThePay - 3 * third;

	const restOfThePayFinal = unbearableAmount + zbytekMzdyZaokrouhleni + (3 - type) * third;
	return restOfThePayFinal;
}

export default function(input) {
	const unbearableAmount = getUnbearableAmount(input.children, input.husband);
	let restOfThePayFinal = getRestOfThePay(input.pay, unbearableAmount, input.type);

	return {
		nezabavitelnaCastka: unbearableAmount,
		exekuceCelkem: input.pay - restOfThePayFinal,
		zbytekMzdyKonecny: restOfThePayFinal,
	};
}
